module.exports = __webpack_public_path__ + "img/logo.19ad0498.png";